export const getInitials = (names, separator = ". ") => names.filter(el => el).map(el => el?.[0] ?? "").join(separator) + "."

export const getCurrentISODate = () => new Date().toISOString().split("T")[0]

export const stringToBoolean = str => {
    if (str?.toLowerCase() === "true") return true
    if (str?.toLowerCase() === "false") return false
    return undefined
}

export const getLookups = (values, field = 'name', separator = ', ', identifier = 'id') => {
    if (Array.isArray(field)) {
        return Object.fromEntries(values.map(el => [el[identifier], field.map(f => el[f]).join(separator)]))
    }
    return Object.fromEntries(values.map(el => [el[identifier], el[field]]))
}

export const getOptions = (values, field = 'id') => values.map(el => el[field])

export const getTimesForSchedule = () => {
    const startDate = new Date("1980-01-01T08:00:00")
    let currentDate = startDate
    let result = [], index = 0
    while (currentDate < new Date("1980-01-01T19:55:00")) {
        const newDate = new Date(currentDate.getTime() + 40 * 1000 * 60)
        result.push({
            id: index,
            start: currentDate.toLocaleTimeString(),
            end: newDate.toLocaleTimeString(),
        })
        currentDate = new Date(newDate.getTime() + 5 * 1000 * 60)
        index += 1
    }
    return result
}

export const getAllDaysInMonth = (month, year) => Array.from(
    { length: new Date(year, month + 1, 0).getDate() },
    (_, i) => new Date(year, month, i + 1)
)